import type { IExportAccessRepository } from '../repositories/IExportAccessRepository.js';
import type { ExportViewEntity } from '../entities/ExportAccessEntity.js';

interface Deps { exportAccessRepository: IExportAccessRepository; }
export function createListExportViewsUseCase({ exportAccessRepository }: Deps) {
  return async function listExportViews(): Promise<ExportViewEntity[]> {
    return exportAccessRepository.listExportViews();
  };
}
